window.addEventListener('DOMContentLoaded', () => {
    window.addEventListener('scroll', function () {
        var cta = document.getElementById('bottom-cta');
        if (!cta) {
            return;
        }

        var scrollPosition = window.scrollY || document.documentElement.scrollTop;
        var triggerPosition = 10;

        if (scrollPosition >= triggerPosition) {
            cta.classList.add('show');
        } else {
            cta.classList.remove('show');
        }
    });
});
